import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Truck, Plus, Trash2, Save } from "lucide-react";

export const DeliverySettings = ({ isAdmin }) => {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/delivery-methods").then((r) => setItems(r.data)); }, []);
  const upd = (i, patch) => setItems(items.map((m, j) => (j === i ? { ...m, ...patch } : m)));
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/delivery-methods", { items: items.map((m) => ({ ...m, fee: Number(m.fee) || 0, per_kg: Number(m.per_kg) || 0, free_above: m.free_above === "" || m.free_above === null || m.free_above === undefined ? null : Number(m.free_above) })) });
      setItems(data); toast.success("Delivery methods saved");
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed to save"); }
    finally { setSaving(false); }
  };
  return (
    <Card className="p-4 space-y-3" data-testid="delivery-settings">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h2 className="font-display font-bold flex items-center gap-2"><Truck className="w-4 h-4" /> Delivery / Pickup Methods</h2>
          <p className="text-xs text-muted-foreground">Regions & courier services. Fee = base fee + per-kg × order weight; free when subtotal reaches the free-delivery threshold.</p>
        </div>
        {isAdmin && (
          <div className="flex gap-2">
            <Button size="sm" variant="outline" onClick={() => setItems([...items, { name: "", courier: "", region: "", fee: 0, per_kg: 0, free_above: "", note: "" }])} data-testid="delivery-add"><Plus className="w-4 h-4 mr-1" /> Add</Button>
            <Button size="sm" onClick={save} disabled={saving} className="bg-cyan-600 hover:bg-cyan-700 text-white" data-testid="delivery-save"><Save className="w-4 h-4 mr-1" /> Save</Button>
          </div>
        )}
      </div>
      <div className="grid grid-cols-[1.2fr_1fr_1fr_90px_90px_100px_1.5fr_32px] gap-2 text-[11px] font-mono uppercase text-muted-foreground px-1"><span>Name</span><span>Courier</span><span>Region</span><span>Base RM</span><span>RM/kg</span><span>Free ≥ RM</span><span>Note</span><span /></div>
      {items.map((m, i) => (
        <div key={i} className="grid grid-cols-[1.2fr_1fr_1fr_90px_90px_100px_1.5fr_32px] gap-2 items-center" data-testid={`delivery-row-${i}`}>
          <Input value={m.name} disabled={!isAdmin} onChange={(e) => upd(i, { name: e.target.value })} data-testid={`delivery-name-${i}`} />
          <Input value={m.courier || ""} disabled={!isAdmin} onChange={(e) => upd(i, { courier: e.target.value })} placeholder="Lalamove / Pos Laju" data-testid={`delivery-courier-${i}`} />
          <Input value={m.region || ""} disabled={!isAdmin} onChange={(e) => upd(i, { region: e.target.value })} placeholder="Klang Valley / West MY" data-testid={`delivery-region-${i}`} />
          <Input type="number" step="0.01" min="0" value={m.fee} disabled={!isAdmin} onChange={(e) => upd(i, { fee: e.target.value })} className="font-mono" data-testid={`delivery-fee-${i}`} />
          <Input type="number" step="0.01" min="0" value={m.per_kg ?? 0} disabled={!isAdmin} onChange={(e) => upd(i, { per_kg: e.target.value })} className="font-mono" data-testid={`delivery-perkg-${i}`} />
          <Input type="number" step="0.01" min="0" value={m.free_above ?? ""} disabled={!isAdmin} onChange={(e) => upd(i, { free_above: e.target.value })} className="font-mono" placeholder="—" data-testid={`delivery-free-${i}`} />
          <Input value={m.note || ""} disabled={!isAdmin} onChange={(e) => upd(i, { note: e.target.value })} data-testid={`delivery-note-${i}`} />
          {isAdmin && <Button size="icon" variant="ghost" className="h-8 w-8 text-rose-600" onClick={() => setItems(items.filter((_, j) => j !== i))} data-testid={`delivery-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>}
        </div>
      ))}
    </Card>
  );
};
